import { Grid, Tooltip} from "@mui/material";

export function getStockorderproductStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'businessid',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        productid:{
            name:'productid',
            label:'Product Id',
            value:'',
            error:false,
            errorMessage:'You must enter Product Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        productname:{
            name:'productname',
            label:'Product Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        qty:{
            name:'qty',
            label:'Qty',
            value:'',
            error:false,
            errorMessage:'You must enter Qty',
            required:true,
            fieldtype:'number'
        },
        matter:{
            name:'matter',
            label:'Matter',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        deliverypriorityid:{
            name:'deliverypriorityid',
            label:'Delivery Priority Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        deliverypriorityname:{
            name:'deliverypriorityname',
            label:'Delivery Priority Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        expecteddelivery:{
            name:'expecteddelivery',
            label:'Expected Delivery',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        printingtype:{
            name:'printingtype',
            label:'Printing Type',
            value:'',
            error:false,
            errorMessage:'You must enter Printing Type',
            required:true,
            fieldtype:'boolean'
        },
        stitchingtype:{
            name:'stitchingtype',
            label:'Stitching Type',
            value:'',
            error:false,
            errorMessage:'You must enter Stitching Type',
            required:true,
            fieldtype:'boolean'
        },
        withprinting:{
            name:'withprinting',
            label:'With Printing',
            value:'',
            error:false,
            errorMessage:'You must enter With Printing',
            required:true,
            fieldtype:'boolean'
        },
        stockorderid:{
            name:'stockorderid',
            label:'Stock Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        receivedqty:{
            name:'receivedqty',
            label:'Received Qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        statusid:{
            name:'statusid',
            label:'Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        statusname:{
            name:'statusname',
            label:'Status Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        remarks:{
            name:'remarks',
            label:'Remarks',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        stitchingworkerid:{
            name:'stitchingworkerid',
            label:'Stitching Worker Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        stitchingworkername:{
            name:'stitchingworkername',
            label:'Stitching Worker Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        stitchingrate:{
            name:'stitchingrate',
            label:'Stitching Rate',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'title', width:150 },
        { field: 'productid', headerName: 'Product Id', width:150 },
        { field: 'productname', headerName: 'Product Name', width:150 },
        { field: 'qty', headerName: 'Qty', width:150 },
        { field: 'matter', headerName: 'Matter', width:150 },
        { field: 'deliverypriorityid', headerName: 'Delivery Priority Id', width:150 },
        { field: 'deliverypriorityname', headerName: 'Delivery Priority Name', width:150 },
        { field: 'expecteddelivery', headerName: 'Expected Delivery', width:150 },
        { field: 'printingtype', headerName: 'Printing Type', width:150 },
        { field: 'stitchingtype', headerName: 'Stitching Type', width:150 },
        { field: 'withprinting', headerName: 'With Printing', width:150 },
        { field: 'stockorderid', headerName: 'Stock Order Id', width:150 },
        { field: 'receivedqty', headerName: 'Received Qty', width:150 },
        { field: 'statusid', headerName: 'Status Id', width:150 },
        { field: 'statusname', headerName: 'Status Name', width:150 },
        { field: 'remarks', headerName: 'Remarks', width:150 },
        { field: 'stitchingworkerid', headerName: 'Stitching Worker Id', width:150 },
        { field: 'stitchingworkername', headerName: 'Stitching Worker Name', width:150 },
        { field: 'stitchingrate', headerName: 'Stitching Rate', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['productname']:{
          ...formValues['productname'],
          value:data.productname,
        },['qty']:{
          ...formValues['qty'],
          value:data.qty,
        },['matter']:{
          ...formValues['matter'],
          value:data.matter,
        },['deliverypriorityid']:{
          ...formValues['deliverypriorityid'],
          value:data.deliverypriorityid,
        },['deliverypriorityname']:{
          ...formValues['deliverypriorityname'],
          value:data.deliverypriorityname,
        },['expecteddelivery']:{
          ...formValues['expecteddelivery'],
          value:data.expecteddelivery,
        },['printingtype']:{
          ...formValues['printingtype'],
          value:data.printingtype,
        },['stitchingtype']:{
          ...formValues['stitchingtype'],
          value:data.stitchingtype,
        },['withprinting']:{
          ...formValues['withprinting'],
          value:data.withprinting,
        },['stockorderid']:{
          ...formValues['stockorderid'],
          value:data.stockorderid,
        },['receivedqty']:{
          ...formValues['receivedqty'],
          value:data.receivedqty,
        },['statusid']:{
          ...formValues['statusid'],
          value:data.statusid,
        },['statusname']:{
          ...formValues['statusname'],
          value:data.statusname,
        },['remarks']:{
          ...formValues['remarks'],
          value:data.remarks,
        },['stitchingworkerid']:{
          ...formValues['stitchingworkerid'],
          value:data.stitchingworkerid,
        },['stitchingworkername']:{
          ...formValues['stitchingworkername'],
          value:data.stitchingworkername,
        },['stitchingrate']:{
          ...formValues['stitchingrate'],
          value:data.stitchingrate,
        },
      })
}